






















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import idTypeList from "../../data/idTypeList";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {}
})
export default class AnnualEITTree extends Vue {
    @Prop({ type: Array })
    treeList?: any[];

    @Prop({ type: Boolean })
    isCheck?: boolean;

    data: any = []
    mounted() {
        if (this.treeList) {
            this.data = this.treeList
        }
    }

    checkNode(as: any, checked: any) {
        // console.log(checked)
        let parentNodes: string[] = [];
        checked.checkedNodes.forEach((node: any, i: number) => {
            if (node.children.length > 0) {
                parentNodes.push(node.label);
            }
        });
        checked.halfCheckedKeys.forEach((n: string) => {
            parentNodes.push(n);
        })
        parentNodes.sort();
        this.$emit("multiCheck", parentNodes.join(","), checked.checkedKeys.join(","));
    }
    check(as: any, node: any, checked: any) {
        if (as.children.length === 0) {
            this.$emit("radioCheck", as.label);
        }
    }

    setSelectedKeys(labels: string[]) {
        (<any>this.$refs.tree).setCheckedKeys(labels);
    }
}
